module.exports = __webpack_public_path__ + "img/ep-bonhomme.91d300a5.png";